import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
      e.target.value = '';
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
          Browse Categories
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8">
          Select a category to explore products on Basetao Spreadsheet
        </p>

        <div className="relative">
          <select
            defaultValue=""
            onChange={handleChange}
            className="w-full appearance-none bg-background-100 border border-background-300/70 rounded-lg px-5 py-4 text-foreground-800 text-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-300/50 focus:border-primary-300 transition-all"
          >
            <option value="" disabled>
              — Choose a Category —
            </option>
            {categories.map((cat) => (
              <option key={cat.name} value={cat.url}>
                {cat.name}
              </option>
            ))}
          </select>
          <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center text-foreground-500">
            <i className="ri-arrow-down-s-line"></i>
          </div>
        </div>
      </div>
    </section>
  );
}